/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Somyaditya Deopuria",
  title: "Hi all, I'm Somyaditya",
  subTitle: emoji(
    "Results-driven Technology & Risk Consultant with experience delivering AML/Transaction Monitoring solutions, technology risk assessments, AI-driven analytics, and blockchain-based Real-World Asset (RWA) solutions for regulated banking environments. Strong background in AML system testing and tuning, risk analytics, data-driven control assessment, technology architecture, and secure application development. Experienced in translating regulatory and business requirements into scalable technology solutions across AI/ML, cloud, blockchain, and enterprise applications. Holds a Master’s degree in Data Analytics and Artificial Intelligence, with a focus on risk, compliance, and data-driven decision-making."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ob_G1VNVWjlmo6enU3vofJBUiSURPua6/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/sd-malinga",
  linkedin: "https://www.linkedin.com/in/somyaditya-deopuria-736a17202",
  gmail: "sdeopuria@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "SOFTWARE ENGINEER FOCUSED ON BACKEND, BLOCKCHAIN, AND AI/ML",
  skills: [
    emoji(
      "⚡ Build enterprise-grade backend platforms, Node.js microservices, and secure RESTful APIs"
    ),
    emoji(
      "⚡ Deliver blockchain and smart contract solutions for real-world asset tokenization"
    ),
    emoji(
      "⚡ Apply data analytics and AI/ML to AML, risk, and compliance workflows"
    ),
    emoji(
      "⚡ Implement cloud-ready systems with CI/CD, Docker, and observability tooling"
    )
  ],

  /* Make sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Express.js",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "Solidity",
      fontAwesomeClassname: "fas fa-file-contract"
    },
    {
      skillName: "Web3.js",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Hong Kong Baptist University",
      logo: require("./assets/images/hkbu_logo.png"),
      subHeader:
        "Master of Science in Data Analytics & Artificial Intelligence",
      duration: "September 2024 - August 2025"
      // desc: "Cours",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Institute of Engineering & Science, IPS Academy",
      logo: require("./assets/images/ips_logo.jpeg"),
      subHeader: "Bachelor of Technology in Computer Science and Engineering",
      duration: "November 2020 - July 2024",
      desc: "GPA: 3.12/4.00"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    },
    {
      Stack: "Blockchain & Smart Contracts",
      progressPercentage: "90%"
    },
    {
      Stack: "Database Management",
      progressPercentage: "80%"
    },
    {
      Stack: "Data Analytics",
      progressPercentage: "75%"
    },
    {
      Stack: "AI / AML",
      progressPercentage: "70%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Associate",
      company: "PricewaterhouseCoopers Hong Kong",
      companylogo: require("./assets/images/pwc-logo.png"),
      date: "November 2025 – Present · Hong Kong",
      desc: "Delivering AI-enabled AML solutions and IT assessments for regulated banking clients.",
      descBullets: [
        "Supported AML Transaction Monitoring (TM) system testing and tuning for banking clients, including parameter calibration, threshold optimisation, and historical-data back-testing to improve detection effectiveness, reduce false positives, and document findings for regulatory and internal audit review.",
        "Developed an interactive TM tuning dashboard consolidating key performance indicators, including alert volumes, conversion rates, and false-positive ratios, and integrated it with an ML pipeline to support automated model retraining and ongoing model governance.",
        "Led the development of an enterprise compliance web application using the MERN stack and Python FastAPI microservices, containerised with Docker and deployed on AWS EC2 to deliver scalable risk and compliance solutions.",
        "Conducted security assessments of banking web applications to identify technology and cyber risks, providing remediation recommendations to strengthen control environments and support regulatory compliance.",
        "Built data models and Power BI dashboards and implemented machine learning solutions using Azure AI services to support risk analytics, anomaly detection, and management reporting."
      ]
    },
    {
      role: "Lead Software Engineer",
      company: "Web4Next Technologies Pvt Ltd",
      companylogo: require("./assets/images/web4next_logo.jpeg"),
      date: "November 2022 – October 2025 · Ahmedabad, India",
      desc: "Led backend and blockchain engineering for real-world asset tokenization platforms.",
      descBullets: [
        "Led backend and blockchain engineering for an enterprise Real-World Asset (RWA) tokenization platform, driving solution architecture, service design, smart contract development, and technology delivery across cross-functional teams.",
        "Architected and governed MongoDB data models across distributed services, optimising data structures and query performance while ensuring data integrity, scalability, and alignment with enterprise data management practices.",
        "Designed, developed, and reviewed Solidity smart contracts for enterprise blockchain applications, including tokenisation and NFT solutions, with a focus on security controls, audit readiness, and performance optimisation.",
        "Led API and system integration across Node.js microservices and React.js applications for a 5-member engineering team, establishing standards for API design, authentication, authorisation, documentation, and secure communication.",
        "Collaborated with business and technology stakeholders to assess and integrate third-party platforms and external APIs, enabling scalable digital asset solutions while addressing technology, security, operational, and regulatory risks."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Microsoft Certified: Azure AI Engineer Associate",
      subtitle:
        "Designed and implemented AI solutions using Azure AI services, Azure AI Search, and Azure Open AI",
      image: require("./assets/images/microsoft-certified-associate-badge.png"),
      imageAlt: "Python Project Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/SomyadityaDeopuria-9565/32B8956620DDEE1C?sharingId"
        }
      ]
    },
    {
      title: "Python for Data Science, AI & Development",
      subtitle:
        "Demonstrated proficiency in using Python libraries such as Pandas & Numpy, and developing code using Jupyter Notebooks.",
      image: require("./assets/images/python_cert.png"),
      imageAlt: "Python Badge Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://coursera.org/share/98cbb4b7e71af870557d182f426af7d5"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  downloadLink:
    "https://www.canva.com/design/DAGQold8ack/Nl9Ac5fX3HQE60sMEdkO-w/view?utm_content=DAGQold8ack&utm_campaign=designshare&utm_medium=link&utm_source=editor", // Make Sure to update the Google Drive Link
  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a role, project or just want to say hi? My Inbox is open for all.",
  email_address: "sdeopuria@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
